import { createContext, useState } from 'react'

export const Context = createContext()

const ContextProvider = ({ children }) => {
  const [toggle, setToggle] = useState(() => window.innerWidth > 1140)

  const [user, setUser] = useState(null)

  return (
    <Context.Provider value={{ toggle, setToggle, user, setUser }}>
      {children}
    </Context.Provider>
  )
}

export default ContextProvider
